import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { env } from 'yargs';
import { VersionService } from './core/services/version.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  /**
   *
   */
  constructor(private router: Router,
    private versionService: VersionService) {
    this.router.events
    .pipe(
        filter((e) => !!(e instanceof NavigationStart)),
        switchMap(() => this.versionService.CheckVersion())
    )
    .subscribe();
    
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd && environment.kioskMode && window.external.UserIsPresent)
        window.external.UserIsPresent();
    });
  }
}
